export default {
    /* GET_PRODUCTION_PROCESSES
    ---------------------------------------------------------------
    */
    GET_PRODUCTION_PROCESSES_REQUEST: state => {
        state.productionProcessesLoading = true
    },
    GET_PRODUCTION_PROCESSES_SUCCESS: (state, data) => {
        state.productionProcesses = data.results
    },
    GET_PRODUCTION_PROCESSES_FAILURE: state => {
        state.productionProcessesLoading = false
    },

    SET_PRODUCT_PRODUCTION_PROCESSES_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PRODUCT_PRODUCTION_PROCESSES_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}